import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import Typography, { VARIANTS } from '@jobcase/react_pattern_library/components/Typography/TypographyRebrand';
import TypographyOld from '@jobcase/react_pattern_library/components/Typography/Typography';
import styles from '@jobcase/react_pattern_library/styles/rebrand';

import Alert from '../../../components/SSO/Alert';
import NativeLogin from '../../../components/SSO/NativeLogin';
import BarredText from '../../../components/SSO/BarredText';
import SocialSignIn from '../../../components/SSO/SocialSignIn';

import { getLoginError } from '../../../redux/nodes/authentication/selectors';
import actions from '../../../redux/nodes/authentication/actions';

import { useSelector } from '../../../utils/hooks';

const CustomHeader = styled.div`
  margin-bottom: ${({ theme }) => `${theme.spacing.default}px`};
  text-align: center;
`;

const LogoWrapper = styled.div`
  color: ${styles.color.jobcaseWhiteColor};
  margin-bottom: ${styles.spacing.tiny}px;
  text-align: center;
  text-decoration: none;
`;

const Image = styled.img`
  max-width: 122px;
  max-height: 22px;
`;

const DoLaterText = styled(TypographyOld)`
  display: block;
  padding-top: ${styles.spacing.extraTiny}px;
  text-align: center;
`;

const Login = ({
  customTitle,
  customSubtitle,
  onLoginSuccess,
  onCreateNewAccount,
}) => {
  const dispatch = useDispatch();
  const error = useSelector(getLoginError);

  const handleLoginSuccess = (signOnType) => {
    if (onLoginSuccess) {
      onLoginSuccess(signOnType);
    }
  };

  useEffect(() => {
    dispatch({
      type: actions.TYPES.SET_LOGIN_ERROR,
      payload: null,
    });
  }, []);

  return (
    <>
      <LogoWrapper>
        <Image src="/static-ec/jobcase-rebrand.svg" alt="Jobcase" />
      </LogoWrapper>
      {customTitle && (
        <CustomHeader>
          <Typography variant={VARIANTS.H2}>{customTitle}</Typography>
        </CustomHeader>
      )}
      {customSubtitle && (
        <CustomHeader>
          <Typography variant={VARIANTS.H3}>{customSubtitle}</Typography>
        </CustomHeader>
      )}
      <Alert alert={error} />
      <SocialSignIn
        onLoginSuccess={handleLoginSuccess}
        isLogin
      />
      <BarredText />
      <NativeLogin
        onCreateNewAccount={onCreateNewAccount}
        onLoginSuccess={handleLoginSuccess}
      />
      <DoLaterText>
        Not ready?&nbsp;
        <TypographyOld
          onClick={onCreateNewAccount}
          isLink
          linkStyle={Typography.LINK_STYLES.HOVER_UNDERLINE}
        >
          Do this later
        </TypographyOld>
      </DoLaterText>
    </>
  );
};

Login.propTypes = {
  customTitle: PropTypes.string,
  customSubtitle: PropTypes.string,
  onLoginSuccess: PropTypes.func,
  onCreateNewAccount: PropTypes.func,
};

Login.defaultProps = {
  customTitle: 'Welcome Back to Jobcase!',
  customSubtitle: null,
  onLoginSuccess: () => {},
  onCreateNewAccount: () => {},
};

export default Login;
